import { useEffect, useState } from "react";

function setTheme(theme) {
  document.documentElement.setAttribute('data-bs-theme', theme)
}

function getTheme() {
  let theme = localStorage.getItem('theme');
  return (theme === 'dark') ? 'dark' : 'light';
}

function Header() {
  let [theme, setInTheme] = useState(getTheme());
  let isDark = (theme === 'dark');
  let icon = isDark ? "sun" : "moon";

  useEffect(() => {
    setTheme(theme);
  });

  let toggleTheme = () => {
    const newTheme = (getTheme() === 'dark') ? 'light' : 'dark';
    localStorage.setItem('theme', newTheme);
    setInTheme(newTheme);
  }

  return (
    <div className='card m-5 pt-1 align-items-center'>
      <div className='m-3 w-100 clearfix'>
        <div className='ms-5 float-start'>
          <h2>The Prisoner's Dilemma</h2>
        </div>
        <div className='me-5 float-end'>
          <button className={`btn ms-3 btn-md`} onClick={toggleTheme}>
            <img src={`/${icon}.svg`} alt={icon} width="20" height="20" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
